// SVG icons
import { ReactComponent as Icon18 } from "@shared/assets/icons/18.svg";
import { ReactComponent as IconAviator } from "@shared/assets/icons/aviator.svg";
import { ReactComponent as IconChineseTag } from "@shared/assets/icons/chinese-ny.svg";
import { ReactComponent as IconChristmas } from "@shared/assets/icons/christmas.svg";
import { ReactComponent as IconClock } from "@shared/assets/icons/clock.svg";
import { ReactComponent as IconClose } from "@shared/assets/icons/close.svg";
import { ReactComponent as IconEighteen } from "@shared/assets/icons/eighteen.svg";
import { ReactComponent as IconScreen } from "@shared/assets/icons/fullscreen.svg";
import { ReactComponent as IconGear } from "@shared/assets/icons/gear.svg";
import { ReactComponent as IconHalloween } from "@shared/assets/icons/halloween.svg";
import { ReactComponent as IconHeart } from "@shared/assets/icons/heart.svg";
import { ReactComponent as IconHide } from "@shared/assets/icons/hide.svg";
import { ReactComponent as IconJackpots } from "@shared/assets/icons/jackpots.svg";
import { ReactComponent as IconArrow } from "@shared/assets/icons/left-arrow.svg";
import { ReactComponent as IconLeft } from "@shared/assets/icons/left-direction.svg";
import { ReactComponent as IconMenu } from "@shared/assets/icons/menu.svg";
import { ReactComponent as IconPresent } from "@shared/assets/icons/present.svg";
import { ReactComponent as IconRefresh } from "@shared/assets/icons/refresh.svg";
import { ReactComponent as IconRotation } from "@shared/assets/icons/rotation.svg";
import { ReactComponent as IconSearch } from "@shared/assets/icons/search.svg";
import { ReactComponent as IconShow } from "@shared/assets/icons/show.svg";
import cx from "classnames";
import PropTypes from "prop-types";

const ICONS = [
  "18",
  "arrow",
  "close",
  "hide",
  "show",
  "gear",
  "left",
  "menu",
  "screen",
  "search",
  "refresh",
  "eighteen",
  "rotation",
  "jackpots",
  "heart",
  "present",
  "aviator",
  "clock",
  "halloween",
  "christmas",
  "chineseTag",
];

/** Set default icon props */
const defaultIconProps = { aspectRatio: 1 };

/** Set icon props by iconName */
const dataMap = {
  18: {
    aspectRatio: 2.2,
  },
};

const iconMap = {
  18: Icon18,
  menu: IconMenu,
  left: IconLeft,
  show: IconShow,
  hide: IconHide,
  gear: IconGear,
  arrow: IconArrow,
  close: IconClose,
  screen: IconScreen,
  search: IconSearch,
  refresh: IconRefresh,
  rotation: IconRotation,
  jackpots: IconJackpots,
  eighteen: IconEighteen,
  heart: IconHeart,
  present: IconPresent,
  aviator: IconAviator,
  clock: IconClock,
  halloween: IconHalloween,
  christmas: IconChristmas,
  chineseTag: IconChineseTag,
};

export const Icon = ({
  name,
  size,
  className,
  isActive,
  activeClass,
  rotate,
  scaleX,
  scaleY,
}) => {
  const IconComponent = iconMap[name] ? iconMap[name] : null;

  // Is interactive tag?!
  const iconProps = {
    ...defaultIconProps,
    ...dataMap[name],
  };

  const width = size * iconProps.aspectRatio;

  const transform = [];
  if (rotate !== 0) {
    transform.push(`rotate(${rotate}deg)`);
  }
  if (scaleX) {
    transform.push("scaleX(-1)");
  }
  if (scaleY) {
    transform.push("scaleY(-1)");
  }
  const iconStyle = transform.length
    ? "transform: " + transform.join(" ")
    : null;

  return (
    <IconComponent
      className={cx(
        "icon",
        `icon--${name}`,
        { [activeClass]: isActive },
        className
      )}
      width={width}
      height={size}
      style={iconStyle}
      role="presentation"
    />
  );
};

Icon.defaultProps = {
  size: 32,
  rotate: 0,
  scaleX: false,
  scaleY: false,
  isActive: false,
  className: "",
  activeClass: "icon--active",
};

// PropTypes
Icon.propTypes = {
  name: PropTypes.oneOf(ICONS).isRequired,
  size: PropTypes.number,
  rotate: PropTypes.number,
  scaleX: PropTypes.bool,
  scaleY: PropTypes.bool,
  isActive: PropTypes.bool,
  className: PropTypes.string,
  activeClass: PropTypes.string,
};
